import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import VerificacionPago from "./EstadosCuentaContent/VerificacionPago";
import Cuentas from "./EstadosCuentaContent/Cuentas";
import RecibosDePago from "./EstadosCuentaContent/RecibosDePago";
import AperturarCuenta from "./EstadosCuentaContent/AperturarCuenta";
import Solvencia from "./EstadosCuentaContent/Solvencia";
import PagosRechazados from "./EstadosCuentaContent/PagosRechazados";

class MainEstadoDeCuenta extends Component {
    state = {
        valorActividad: { value: 'cuentas', label: 'Estados de Cuenta' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/estados_de_cuenta/verificacion_pago": return({ value: 'verificacion_pago', label: 'Verificación de Pagos' })
            case "/estados_de_cuenta/cuentas": return({ value: 'cuentas', label: 'Estados de Cuenta' })
            case "/estados_de_cuenta/nueva_cuenta": return({ value: 'new_cuenta', label: 'Aperturar Cuenta' })
            case "/estados_de_cuenta/recibos": return({ value: 'recibos', label: 'Recibos de Pago' })
            case "/estados_de_cuenta/solvencia": return({ value: 'solvencia', label: 'Solvencia Administrativa' })
            case "/estados_de_cuenta/pagos_rechazados": return({ value: 'pagos_rechazados', label: 'Pagos Rechazados' })
            default: return({ value: 'cuentas', label: 'Estados de Cuenta' })
        }
    }

    valorEstadosLabel = (link) => {
        switch (link) {
            case "/estados_de_cuenta/verificacion_pago": return('Verificación de Pagos')
            case "/estados_de_cuenta/cuentas": return('Estados de Cuenta')
            case "/estados_de_cuenta/nueva_cuenta": return('Aperturar Cuenta')
            case "/estados_de_cuenta/recibos": return('Recibos de Pago')
            case "/estados_de_cuenta/solvencia": return('Solvencia Administrativa')
            case "/estados_de_cuenta/pagos_rechazados": return('Pagos Rechazados')
            default: return('Estados de Cuenta')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/estados_de_cuenta/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/estados_de_cuenta/verificacion_pago" component={ () => <VerificacionPago/> } />
                <Route path="/estados_de_cuenta/cuentas" component={ () => <Cuentas /> } />
                <Route path="/estados_de_cuenta/nueva_cuenta" component={ () => <AperturarCuenta /> } />
                <Route path="/estados_de_cuenta/recibos" component={ () => <RecibosDePago /> } />
                <Route path="/estados_de_cuenta/solvencia" component={ () => <Solvencia /> } />
                <Route path="/estados_de_cuenta/pagos_rechazados" component={ () => <PagosRechazados /> } />
                <Redirect to = "/estados_de_cuenta/cuentas" />
            </Switch>
        )
    }

    render() {
        const Opciones = [
            { value: 'cuentas', label: 'Estados de Cuenta' },
            { value: 'verificacion_pago', label: 'Verificación de Pagos' },
            { value: 'pagos_rechazados', label: 'Pagos Rechazados' },
            { value: 'nueva_cuenta', label: 'Aperturar Cuenta' },
            { value: 'recibos', label: 'Recibos de Pago' },
            { value: 'solvencia', label: 'Solvencia Adminsitrativa' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una actividad
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorEstadosLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainEstadoDeCuenta;


// WEBPACK FOOTER //
// ./src/views/Administracion/MainEstadoDeCuenta.jsx